var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.log(_vm.value)}}},[_c('qrcode-vue',{attrs:{"value":_vm.value,"size":_vm.size,"render-as":_vm.renderAs,"level":_vm.level,"foreground":_vm.foreground,"background":_vm.background}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }